module.exports = __webpack_public_path__ + "static/media/empty-shared.18501622.png";